import React from 'react';
import { IIconProps } from './utils';

export const Writing = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M26.25 16.25L26.25 22.5C26.25 24.5711 24.5711 26.25 22.5 26.25H21.25H7.5C5.42893 26.25 3.75 24.5711 3.75 22.5V13.75M13.75 3.75H7.5C5.42893 3.75 3.75 5.42893 3.75 7.5V8.75M20.8666 5.83333L12.4283 14.2717C12.1979 14.502 12.0409 14.7954 11.977 15.1148L11.4339 17.8307C11.3464 18.268 11.732 18.6536 12.1693 18.5661L14.8852 18.023C15.2046 17.9591 15.498 17.8021 15.7283 17.5717L24.1667 9.13336M20.8666 5.83333L22.4667 4.23328C23.1111 3.58891 24.1558 3.58891 24.8002 4.23328L25.7667 5.19983C26.4111 5.8442 26.4111 6.88894 25.7667 7.53331L24.1667 9.13336M20.8666 5.83333L24.1667 9.13336"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
